module.exports = __webpack_public_path__ + "img/product-smoke-1.59d8c6f2.jpg";